export const ENTITY_MAP = {
  1: 'Organization',
  2: 'Program',
  8: 'Report Category',
  9: 'Organization',
  10: 'Funding Opportunity',
  11: 'System'
};

export const ENTITY_MAP_PLURAL = {
  1: 'Organizations',
  2: 'Programs',
  8: 'Report Categories',
  9: 'Organizations',
  10: 'Funding Opportunities',
  11: 'System'
};

export const AOR_ROLE = 1;
export const GRANT_WRITER_ROLE = 19;
export const SAR_ROLE = 21;

export const ROLE_MAP_INTERNAL = {
  3: 'Program Administrator',
  4: 'Grants Management Specialist',
  5: 'Assistance Officer',
  6: 'Program Specialist',
  8: 'Authorized Signatory Authority',
  13: 'EHP Administrator',
  14: 'EHP Reviewer',
  15: 'Grants Counsel Staff',
  16: 'Grants Counsel Administrator',
  23: 'Panel Review Administrator',
  25: 'Analytics User',
  26: 'Analytics Administrator',
  28: 'Senior Program Administrator',
  31: 'Authorized Signatory Authority, Region 1',
  32: 'Authorized Signatory Authority, Region 2',
  33: 'Authorized Signatory Authority, Region 3',
  34: 'Authorized Signatory Authority, Region 4',
  35: 'Authorized Signatory Authority, Region 5',
  36: 'Authorized Signatory Authority, Region 6',
  37: 'Authorized Signatory Authority, Region 7',
  38: 'Authorized Signatory Authority, Region 8',
  39: 'Authorized Signatory Authority, Region 9',
  40: 'Authorized Signatory Authority, Region 10',
  41: 'System Owner',
  42: 'Service Management Administrator',
  43: 'Human Resources Liaison',
  44: 'Service Management User',
  45: 'Obligating Authority POC',
  46: 'Senior Assistance Officer',
  47: 'Senior EHP Administrator',
  48: 'Senior Grants Counsel Administrator',
  49: 'Senior Analytics Administrator',
  50: 'Designated De-obligating Authority',
  51: 'Designated De-obligating Authority, Region 1',
  52: 'Designated De-obligating Authority, Region 2',
  53: 'Designated De-obligating Authority, Region 3',
  54: 'Designated De-obligating Authority, Region 4',
  55: 'Designated De-obligating Authority, Region 5',
  56: 'Designated De-obligating Authority, Region 6',
  57: 'Designated De-obligating Authority, Region 7',
  58: 'Designated De-obligating Authority, Region 8',
  59: 'Designated De-obligating Authority, Region 9',
  60: 'Designated De-obligating Authority, Region 10',
  61: 'Read Only'
}

export const REGIONAL_ROLE_MAP_INTERNAL = {
  31: 'Regional Authorized Signatory Authority',
  32: 'Regional Authorized Signatory Authority',
  33: 'Regional Authorized Signatory Authority',
  34: 'Regional Authorized Signatory Authority',
  35: 'Regional Authorized Signatory Authority',
  36: 'Regional Authorized Signatory Authority',
  37: 'Regional Authorized Signatory Authority',
  38: 'Regional Authorized Signatory Authority',
  39: 'Regional Authorized Signatory Authority',
  40: 'Regional Authorized Signatory Authority',
  51: 'Regional Designated De-obligating Authority',
  52: 'Regional Designated De-obligating Authority',
  53: 'Regional Designated De-obligating Authority',
  54: 'Regional Designated De-obligating Authority',
  55: 'Regional Designated De-obligating Authority',
  56: 'Regional Designated De-obligating Authority',
  57: 'Regional Designated De-obligating Authority',
  58: 'Regional Designated De-obligating Authority',
  59: 'Regional Designated De-obligating Authority',
  60: 'Regional Designated De-obligating Authority',
}

export const PERMISSIONS_MAP_INTERNAL = {
  'Analytics Administrator': 'can view and export reports from the reports page, as well as manage the users within their report category.',
  'Analytics User': 'can view and export reports from the reports page.',
  'Assistance Officer': 'can perform grants management supervisory tasks, manage the grants management users within their program, and can see management dashboards.',
  'Authorized Signatory Authority': 'able to complete award signature tasks and amendment signature tasks for their program, and can see management dashboards.',
  'Designated De-obligating Authority': 'able to complete de-obligation approval tasks during pre-award, amendments, and closeout for their program, and can see management dashboards.',
  'EHP Administrator': 'can perform EHP tasks, manage the EHP users within their program, and can see management dashboards.',
  'EHP Reviewer': 'conducts EHP tasks.',
  'Grants Counsel Administrator': 'can perform Grants Counsel tasks, manage the Grants Counsel users within their program, and can see management dashboards.',
  'Grants Counsel Staff': 'conducts Grants Counsel tasks.',
  'Grants Management Specialist': 'conducts grants management tasks.',
  'Human Resources Liaison': 'can manage any user roles and permissions within their Organization, with the exception of the signature authorities.',
  'Obligating Authority POC': 'can manage permissions for ASAs and DOAs within their program/region.',
  'Program Administrator': 'can perform programmatic supervisory tasks, manage the programmatic users within their program, and can see management dashboards.',
  'Program Specialist': 'conducts programmatic tasks.',
  'Read Only': 'can view, but not edit, information within the program for which they are authorized.',
  'Regional Authorized Signatory Authority': 'able to complete award signature tasks and amendment signature tasks for their region in their program, and can see management dashboards.',
  'Regional Designated De-obligating Authority': 'able to complete de-obligation approval tasks during pre-award, amendments, and closeout for their region in their program, and can see management dashboards.',
  'Senior Program Administrator': 'senior-most programmatic user. Can perform programmatic supervisory tasks, manage the programmatic users within their program, and can see management dashboards.',
  'Service Management Administrator': 'can conduct service management supervisory tasks, manage the service management users within the system, and can see management dashboards.',
  'Service Management User': 'conducts service management task.',
  'Senior Analytics Administrator': 'senior-most analytics user. Can view and export reports from the reports page, as well as manage the users within their report category.',
  'Senior Assistance Officer': 'senior-most grants management user. Can perform grants management supervisory tasks, manage the grants management users within their program, and can see management dashboards.',
  'Senior EHP Administrator': 'senior-most EHP user. Can perform EHP tasks, manage the EHP users within their program, and can see management dashboards.',
  'Senior Grants Counsel Administrator': 'senior-most Grants Counsel user. Can perform Grants Counsel tasks, manage the Grants Counsel users within their program, and can see management dashboards.',
  'System Owner': 'can manage system level administrators and Human Resource Liaisons.',
  'Panel Review Administrator': 'conducts selection for panels task, can access panel administration for their program, can manage applications, subapplications, reviewers, groups, and panel chairs for panels sessions.'
}

export const ROLE_MAP = {
  [AOR_ROLE]: 'Authorized Organization Representative',
  2: 'Organization Member',
  3: 'Program Administrator',
  4: 'Grants Management Specialist',
  5: 'Assistance Officer',
  6: 'Program Specialist',
  12: 'Panel Review Coordinator',
  13: 'EHP Administrator',
  14: 'EHP Reviewer',
  15: 'Grants Counsel Staff',
  16: 'Grants Counsel Administrator',
  17: 'Programmatic Member',
  18: 'Financial Member',
  [GRANT_WRITER_ROLE]: 'Grant Writer',
  20: 'Subrecipient Member',
  21: 'Subrecipient Authorized Representative'
};

export const PERMISSIONS_MAP = {
  'Program Administrator': `can grant and remove Program Specialist and Program Administrator role, has all privileges of the Program Specialist, and can see management dashboards.`,
  'Program Specialist': `conducts programmatic tasks.`,
  'Assistance Officer': `can grant the Grants Management Specialist and Assistance Officer roles, has all privileges of the Grants Management Specialist, and can see management dashboards.`,
  'Grants Management specialist': `conducts grants management tasks.`,
  'EHP Administrator': `can grant the EHP Reviewer and EHP Administrator role, has all privileges of the EHP Reviewer, and can see management dashboards.`,
  'EHP Reviewer': `conducts EHP tasks.`,
  'Grants Counsel Staff': `conducts Grant Counsel tasks.`,
  'Grants Counsel Administrator': `can grant the Grants Counsel Staff and Grants Counsel Administrator role, has all privileges of the Grant Counsel Staff, and can see management dashboards.`,
  'Authorized Organization Representative': `can manage team members and has all the permissions for the organization, including submitting information to FEMA.`,
  'Organization Member': `can view and edit all information, but cannot submit to FEMA or manage teams.`,
  'Programmatic Member':
    'can view and edit all information and can only submit amendments and programmatic reports.',
  'Financial Member':
    'can view and edit all information, and can only submit payments or draw down requests, financial reports, and amendments.',
  'Grant Writer':
    'can view and edit all information for an application or subapplication.',
  'Subrecipient Member': 'can view and edit a subapplication.',
  'Subrecipient Authorized Representative':
    'can view, edit, and submit a subapplication and give other users subrecipient role permissions.',
  ...PERMISSIONS_MAP_INTERNAL
};

export const PERMISSIONS_MAP_V2 = {
  ...PERMISSIONS_MAP,
  'Grant Writer': 'can view and edit all information for an application.',
};

export const addMemberText = `Enter an email address for a colleague to add to
your organization. Then identify the role and grant programs
(optional) to assign within the FEMA GO system. If you do not
choose a grant program or group of grant programs, the user will
be assigned the role you choose for all grant programs you belong
to in the system.`;

export const addSubMemberText = `Select a user from the list below to give them permission to take actions as a subrecipient to your 
organization for this suborganization. To give permissions, the user must already be registered in FEMA GO 
and associated with the suborganizations. If you do not see a user in the list, the suborganization must first 
give them access in FEMA GO.`;

export const addManSubMemberText =
  'Enter the email address of the user you would like to add to your suborganization. Then identify the role and grant programs to assign within the FEMA GO system.';
export const grantWriterToggledText =
  'can view and edit all information for an application.';

export const email_regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const SARROLES = ['20', '21'];
export const AOR_SAR_ROLES = ['1', '2', '17', '18', '19', '20', '21'];
export const AOR_ROLES = ['1', '2', '17', '18', '19'];

export const ROLE_TO_ROLES_MAP = {
  '3': ['3', '6'],
  '5': ['4', '5'],
  '1': AOR_ROLES,
  '13': ['13', '14'], // EHP roles
  '16': ['15', '16'], // OCC roles
  '21': SARROLES,
};

export const ROLE_TO_ROLES_MAP_v2 = {
  '3': ['3', '6'],
  '5': ['4', '5'],
  '1': AOR_SAR_ROLES,
  '13': ['13', '14'], // EHP roles
  '16': ['15', '16'], // OCC roles
  '21': SARROLES,
};

export const MITIGATION_PROGRAMS = [13, 14, 15, 16, 17];
